import type {ReactElement} from 'react';
import React from 'react';
import useDefaultPanelClose from '@Panels/hooks/useDefaultPanelClose';
import {useUpdateEffect} from 'ahooks';
import {TextBackgroundPanel} from '@Panels/poster-editor-item-background-panel/components/text-background-panel';
import {LayoutBackgroundPanel} from '@Panels/poster-editor-item-background-panel/components/layout-background-panel';
import {TextslideBackgroundPanel} from '@Panels/poster-editor-item-background-panel/components/textslide-background-panel';
import {TranscriptBackgroundPanel} from '@Panels/poster-editor-item-background-panel/components/transcript-background-panel/transcript-background-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';

interface PosterEditorItemBackgroundPanelProps {
  panelId: string;
}

export default function PosterEditorItemBackgroundPanel({...props}: PosterEditorItemBackgroundPanelProps): ReactElement | null {
  const onClose = useDefaultPanelClose(props.panelId);
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();

  useUpdateEffect((): void => {
    onClose();
  }, [activeItemId]);

  useUpdateEffect((): void => {
    if (activeItem?.isSlideshow()) {
      onClose();
    }
  }, [activeSlideUID]);

  if (activeItem?.isTranscript()) {
    return <TranscriptBackgroundPanel onClose={onClose} panelId={props.panelId} />;
  }

  if (activeItem?.isText()) {
    return <TextBackgroundPanel onClose={onClose} panelId={props.panelId} />;
  }

  if (activeItem?.isSlideshow()) {
    return <TextslideBackgroundPanel onClose={onClose} panelId={props.panelId} />;
  }

  if (activeItem?.isTableItem() || activeItem?.isMenu() || activeItem?.isTab()) {
    return <LayoutBackgroundPanel onClose={onClose} panelId={props.panelId} />;
  }

  return null;
}
